"use client";

import { createContext, useContext, type ReactNode } from "react";

const LandingCasesPageContext = createContext<string[]>([]);

export function LandingCasesPageProvider({
  reportTypes,
  children,
}: {
  reportTypes: string[];
  children: ReactNode;
}) {
  return (
    <LandingCasesPageContext.Provider value={reportTypes}>
      {children}
    </LandingCasesPageContext.Provider>
  );
}

export function useLandingCasesPageReportTypes(): string[] {
  return useContext(LandingCasesPageContext);
}
